/*
The language manager

This will be built in stages

1) create storage for the names of the locales and create a menu for them

2) animate this menu

3) make the links

4) do cookie checking etc to pre select language

*/
var lM = {
	trans: null,
	menuItems: null,
    menuSort: [],
    localeKeys:[],
    localeKeysRev:{},

	settings: null,
    ck: null,
	init: function(defaults){
        //need to make sure we can read the locale first, or just stop everything
        if(eM.cP.localeAbs != null){
            var i =this;
            if(typeof $.cookie != "undefined"){

                $.cookie('psForumLocale', eM.cP.localeAbs, { "expires": 352, "path": '/', "domain": window.location.hostname});
            }
            //i.addCss();

            //i.setDefaults(defaults);
            //i.makeMenu();
        }
	
	},
	setDefaults: function(defaults){
		var i = this;
        //can't getTrans - as we want everything!
        i.trans = transManager.getAllTrans();
        //console.log(i.trans);
		i.settings = {target: $('#langTarget')};

		if(typeof(defaults) != "undefined"){
			//we're going to set our own values
			for(var k in defaults){
			
				i.settings[k] = defaults[k];
			}
		
		}
	
	
	},
    //no longer used
    /*addCss: function(){
        $('head').append('<link rel="stylesheet" href="'+eM.server+'/assets/lang/lang.css" type="text/css" />');    
    },*/
	getMenuItems: function(){
		var i = this;
		if(i.menuItems == null){
			//go through trans, and get the country label for each locale key
			var lookup = eM.getReverseLocaleLookup();
            //console.log(lookup);
                        //console.log(i.trans);

			//we will set a link in the trans, but it's optional
			i.menuItems = {};
            var x = 0;
			for(var k in lookup){
				i.menuItems[k] = {index:x,label: i.trans[k].lang,link:"/t5/x/ct-p/"+lookup[k]};
                //could make the links at this stage as well
                i.menuSort[x] = i.trans[k].lang;
                //we want to be able to find the array key from the locale
                i.localeKeys[x] = k;
                i.localeKeysRev[i.trans[k].lang] = {key:k,index:x};

                x++;
                
			
			}


		
		}
		//console.log(i.menuItems);
        return i.menuItems;
	
	},
    getLocale: function(){
        //portalLocaleCookie
        //either from eM, or we look at the psForumLocale to see a locale there
        return eM.cP.localeAbs;
        /*var i = this;
        if(i.cookie == null){
            i.cookie = $.cookie('psForumLocale');
        }
        return i.cookie;*/
    },
	makeMenu: function(){
		var i = this;
		var list = i.getMenuItems();
		//console.log(list);
        i.render();
        i.makeUI();
	
	},
    render: function(){
        var i = this;
        //get the current locale one
        var tempItems = [];
        var mI = i.menuItems;

        for(var k in i.menuSort){
            tempItems[k] = i.menuSort[k];
        
        }
        var curLocale = i.getLocale();
        //console.log(curLocale);
        //we might be on a hidden board of something
        if(mI.hasOwnProperty(curLocale)){
	        var curLocaleItem = mI[curLocale];

	        delete(tempItems[mI[curLocale].index]);

        } else {
        	var curLocaleItem = {};
        	curLocaleItem.label = 'hidden board';
        }
        tempItems.sort();
        //console.log(tempItems);
        var s = '<div id="langWrapper" style="display:none">';
        s += '<h3>'+$("#dict_select_lang").html()+':</h3>';

        s += '<div id="langHolder">';
        s += '<div id="langHeader">';
        //s += '<h3 id="'+curLocale+'_flag">'+curLocaleItem.label+'<span></span><b></b></h3>';
        s += '<h3 id="'+curLocale+'_flag">'+curLocaleItem.label+'<b></b></h3>';

        s += '</div>';
        s += '<div id="langSelList" style="display:none">';
        s += '<ul>';


        for(var c in tempItems){
            var x = i.localeKeysRev[tempItems[c]].key;
            //console.log(x);
            //s += '<li><a id="'+x+'_flag" href="'+mI[x].link+'">'+mI[x].label+'<span></span></a></li>';

            s += '<li><a id="'+x+'_flag" href="'+mI[x].link+'">'+mI[x].label+'</a></li>';
        
        }
        s += '</ul>';

        s += '</div>';
        s += '</div>';
        s += '</div>';

        i.place(s);
        $("#langWrapper").fadeIn(400,'easeInCubic');
    },
    place: function(str){
        this.settings.target.append(str);
    
    },
    makeUI: function(){
        $("#langHeader").click(function(){
            $("#langSelList").slideToggle(200,'easeOutCubic');
        
        
        });
    
    }


};